// extracted by mini-css-extract-plugin
export default {"coreS":"WeCare_coreS__i50Fl","big":"WeCare_big__K-4ng","c_item":"WeCare_c_item__j+O13","fadein":"WeCare_fadein__Ey2b-","visible":"WeCare_visible__3SAFK"};